import { DataSource } from "../databinding/DataSource";
import { Event, EventListener } from "./Event";

export interface DataSourceSubscriberErrorListener extends EventListener<DataSourceSubscriberErrorEvent> {
}

export class DataSourceSubscriberErrorEvent extends Event<DataSource> {
    private _error: string;

    constructor(dataSource: DataSource, error: string) {
        super(dataSource, null);
        this._error = error;
    }

    public get dataSource(): DataSource {
        return this.target;
    }

    public get error(): string {
        return this._error;
    }
}
